module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_vm._v("“READING PHILIP R. CRAIG IS ARMCHAIR"), _c('br'), _vm._v("TRAVELING AT ITS FINEST.”")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "center1"
  }, [_vm._v("Alfred Hitchcock Mystery Magazine")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("DEATH ON A VINEYARD BEACH")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("“THERE’S REAL CRIME HERE, GREED, BETRAYAL"), _c('br'), _vm._v("AND MURDER TIED IN A PLAUSIBLE PUZZLE, but"), _c('br'), _vm._v("Craig’s series owes most of its charm to the Vineyard"), _c('br'), _vm._v("and his intelligent, likable characters.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Publishers Weekly")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("“JUST THE COMPANION FOR A DAY ON THE"), _c('br'), _vm._v("BEACH OR IN THE BACKYARD HAMMOCK . . ."), _c('br'), _vm._v("Close your eyes and imagine that Robert Parker’s"), _c('br'), _vm._v("Spencer had to enter the witness protection program."), _c('br'), _vm._v("Now his name is J.W. Jackson, and he is"), _c('br'), _vm._v("summering on Martha’s Vineyard.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Mystery News")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("“APPEALING… The humanization of the gangster"), _c('br'), _vm._v("family, the peeks behind the Vineyard facades, and the"), _c('br'), _vm._v("beach environment will win those who like their reading "), _c('br'), _vm._v("to be as leisurely as a long summer’s afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Boston Herald")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("“ONE OF THE MOST UNDERRATED WRITERS IN"), _c('br'), _vm._v("THE GENRE… Craig is a consummate storyteller.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Murder & Mayhem")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88bb2822","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm01.vue
// module id = 60
// module chunks = 0